import { Form } from '@unform/web';
import styled from 'styled-components';

export const WrapperForm = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding: 0;
  flex-wrap: nowrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const IconWrapper = styled(Form)`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
